(() => {
  const dialog = document.querySelector('#FrematWall');
  if (!dialog) return;
  const data = JSON.parse(document.querySelector('#FrematWallData').textContent);
  const $ = s => dialog.querySelector(s);
  const canvas = $('canvas'), ctx = canvas.getContext('2d');
  const status = $('[data-fw-status]'), picker = $('[data-fw-variant]');
  const mount = document.querySelector('#FrematWallMount');
  const target = document.querySelector('.product-info .product-form,.product-info--fremat .product-form');
  if (target) target.prepend(mount); else document.querySelector('#MainContent').prepend(mount);
  mount.hidden = false;
  let photo = null, sample = false, ratio = null, baseRatio = null;
  let images = [], loaded = false, busy = false, dragging = false, uploadSerial = 0;
  let centre = {x:.5,y:.35}, lastFocus, previousOverflow;
  const isFixed = data.kind === 'gallery' || data.kind === 'shelf';
  const productBorder = document.querySelector('[data-remove-white-border]');
  const requestedBorder = new URLSearchParams(location.search).get('wall_border');
  if(productBorder && ['yes','no'].includes(requestedBorder)) {
    productBorder.checked = requestedBorder === 'no';
    productBorder.dispatchEvent(new Event('change',{bubbles:true}));
  }
  $('[data-fw-gap-label]').hidden = !['pair','trio'].includes(data.kind);
  const variant = () => data.variants.find(v => String(v.id) === picker.value);
  const say = message => { status.textContent = message; };
  const loadImage = url => new Promise((resolve,reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('Artwork could not load. Please try again.'));
    image.src = url;
  });
  async function prepareArt() {
    if (loaded || busy) return;
    busy = true;
    say('Loading your artwork…');
    try {
      const urls = (isFixed ? data.layout.frames.map(f=>f.art_url) : data.source.split('^')).map(u=>u?.startsWith('//')?'https:'+u:u);
      if (!urls.length || urls.some(u=>!u || !/^https?:\/\//.test(u))) throw new Error('The artwork for this item is not ready for preview.');
      images = await Promise.all(urls.map(loadImage));
      loaded = true;
      if(!photo&&!sample) say('Choose your wall photo or try the sample wall.');
      draw();
    } catch (error) { say(error.message); }
    finally { busy = false; }
  }
  function composition() {
    if (isFixed) {
      const frames = data.layout.frames.map((f,i)=>({...f,image:images[i],crop:null}));
      return {frames,width:Number(data.layout.total_width),height:Number(data.layout.total_height)+(data.kind==='shelf'?Number(data.layout.shelf_thickness||4):0)};
    }
    const v = variant();
    const match = (v?.options?.join(' ') || v?.title || '').match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
    if (!match) return null;
    const width = Math.min(+match[1],+match[2]), height = Math.max(+match[1],+match[2]);
    const count = data.kind==='trio'?3:data.kind==='pair'?2:1;
    const gap = Math.max(0,Math.min(30,Number($('[data-fw-gap]').value)||0));
    const cropParts = (data.crop || '').split('|').slice(1).map(s=>s.trim().split(/\s+/).map(Number));
    const frames = Array.from({length:count},(_,i)=>({width,height,left:i*(width+gap),top:0,image:images.length===count?images[i]:images[0],crop:images.length===count&&count>1?null:cropParts[i]}));
    if(count===2&&images.length===1&&cropParts.length!==2) return null;
    return {frames,width:count*width+(count-1)*gap,height};
  }
  function artRect(image,crop,x,y,w,h) {
    if(!image) return;
    let [sx,sy,sw,sh] = crop?.length===4?crop:[0,0,image.naturalWidth,image.naturalHeight];
    if(!(sw>0&&sh>0)) return;
    const scale = Math.max(w/sw,h/sh), cw=w/scale,ch=h/scale;
    sx+=(sw-cw)/2; sy+=(sh-ch)/2;
    ctx.drawImage(image,sx,sy,cw,ch,x,y,w,h);
  }
  function draw() {
    ctx.clearRect(0,0,canvas.width,canvas.height);
    if(photo) ctx.drawImage(photo,0,0,canvas.width,canvas.height);
    else {
      ctx.fillStyle='#e7e3dc';ctx.fillRect(0,0,canvas.width,canvas.height);
      if(sample){
        ctx.fillStyle='#c5bbaa';ctx.fillRect(0,690,1200,210);
        ctx.fillStyle='#9b998d';ctx.fillRect(270,550,660,210);
        ctx.fillStyle='#b5b2a5';ctx.fillRect(285,535,305,160);ctx.fillRect(610,535,305,160);
        ctx.fillStyle='#333';ctx.font='20px Arial';ctx.fillText('Illustrative sample wall · 400 cm wide',30,860);
      } else {ctx.fillStyle='#555';ctx.font='28px Arial';ctx.textAlign='center';ctx.fillText('Add your wall photo to begin',canvas.width/2,canvas.height/2);ctx.textAlign='left';}
    }
    const c=composition();
    const current=variant();
    const cont=$('[data-fw-continue]');
    const next=new URL(data.url,location.origin);next.searchParams.set('variant',picker.value);
    next.searchParams.set('wall_border',$('[data-fw-border]').checked?'yes':'no');
    cont.href=next.pathname+next.search;
    cont.hidden=!current?.available;
    $('[data-fw-size]').textContent=c?`${c.width} × ${c.height} cm arrangement${isFixed?'':' · selected print sizes'}${current?.available?'':' · Unavailable'}`:'Size data unavailable for this preview.';
    $('[data-fw-download]').disabled=!loaded||!ratio||!(photo||sample);
    if(c&&loaded&&ratio&&(photo||sample)){
      const w=c.width*ratio,h=c.height*ratio;
      const fits=w<=canvas.width&&h<=canvas.height;
      const x=fits?Math.max(0,Math.min(canvas.width-w,centre.x*canvas.width-w/2)):centre.x*canvas.width-w/2;
      const y=fits?Math.max(0,Math.min(canvas.height-h,centre.y*canvas.height-h/2)):centre.y*canvas.height-h/2;
      const colour=(current?.title||'').toLowerCase();
      const finish=colour.includes('gold')?'#ba9552':colour.includes('white')?'#fafafa':colour.includes('wood')?'#a77948':'#171717';
      c.frames.forEach(f=>{
        const fx=x+f.left*ratio,fy=y+f.top*ratio,fw=f.width*ratio,fh=f.height*ratio;
        const edge=Math.max(1,Math.min(fw,fh)*.025);
        ctx.save();ctx.shadowColor='#0006';ctx.shadowBlur=6;ctx.shadowOffsetY=3;
        ctx.fillStyle=finish;ctx.fillRect(fx,fy,fw,fh);ctx.restore();
        ctx.fillStyle='white';ctx.fillRect(fx+edge,fy+edge,fw-2*edge,fh-2*edge);
        const border=$('[data-fw-border]').checked?2*ratio:0;
        const inset=edge+border;
        artRect(f.image,f.crop,fx+inset,fy+inset,fw-2*inset,fh-2*inset);
      });
      if(data.kind==='shelf') {ctx.fillStyle='#a57542';ctx.fillRect(x,y+data.layout.total_height*ratio,w,Number(data.layout.shelf_thickness||4)*ratio);}
      if(!fits) say('This arrangement extends beyond the photo. Reduce Preview size or choose a smaller product size.');
    }
  }
  function sampleWall(){photo=null;sample=true;baseRatio=3;ratio=3;$('[data-fw-zoom]').value=100;canvas.width=1200;canvas.height=900;centre={x:.5,y:.35};say('Select a size and drag to position. Adjust Preview size to suit your photo.');draw();}
  document.querySelector('[data-fw-open]').addEventListener('click',()=>{
    lastFocus=document.activeElement;
    const selected=document.querySelector('.product-form [name="id"]')?.value;
    if(data.variants.some(v=>String(v.id)===selected))picker.value=selected;
    if(productBorder) $('[data-fw-border]').checked=!productBorder.checked;
    previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';
    dialog.showModal();draw();prepareArt();
  });
  $('[data-fw-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>{document.body.style.overflow=previousOverflow;lastFocus?.focus();});
  $('[data-fw-sample]').addEventListener('click',sampleWall);
  dialog.querySelectorAll('[data-fw-photo]').forEach(input=>input.addEventListener('change',async()=>{
    const file=input.files[0];if(!file)return;
    const serial=++uploadSerial;
    if(file.size>25*1024*1024){say('Please choose a photo smaller than 25 MB.');input.value='';return;}
    const url=URL.createObjectURL(file);
    try{
      const image=await loadImage(url);if(serial!==uploadSerial)return;
      photo=image;sample=false;
      const scale=Math.min(1,1600/Math.max(image.naturalWidth,image.naturalHeight));
      canvas.width=Math.round(image.naturalWidth*scale);canvas.height=Math.round(image.naturalHeight*scale);
      const c=composition();
      baseRatio=c?Math.min(canvas.width*.5/c.width,canvas.height*.4/c.height):canvas.width/400;
      ratio=baseRatio;$('[data-fw-zoom]').value=100;centre={x:.5,y:.35};
      say('Drag to position. Adjust Preview size to suit your wall photo. Sizes are approximate.');draw();
    }catch(error){say('Could not read this photo. Try a JPG, PNG or WebP image.');}
    finally{URL.revokeObjectURL(url);input.value='';}
  }));
  $('[data-fw-zoom]').addEventListener('input',e=>{if(!baseRatio)return;ratio=baseRatio*Number(e.target.value)/100;say('Approximate preview size adjusted. Drag to position.');draw();});
  function point(e){const r=canvas.getBoundingClientRect();const scale=Math.min(r.width/canvas.width,r.height/canvas.height);const ox=(r.width-canvas.width*scale)/2,oy=(r.height-canvas.height*scale)/2;return{x:(e.clientX-r.left-ox)/scale,y:(e.clientY-r.top-oy)/scale};}
  canvas.addEventListener('pointerdown',e=>{
    if(!photo&&!sample)return;
    const p=point(e);if(p.x<0||p.x>canvas.width||p.y<0||p.y>canvas.height)return;
    if(!ratio)return;dragging=true;canvas.setPointerCapture(e.pointerId);move(p);
  });
  function move(p){centre={x:Math.max(0,Math.min(1,p.x/canvas.width)),y:Math.max(0,Math.min(1,p.y/canvas.height))};$('[data-fw-x]').value=centre.x*100;$('[data-fw-y]').value=centre.y*100;draw();}
  canvas.addEventListener('pointermove',e=>{if(dragging)move(point(e));});
  canvas.addEventListener('pointerup',()=>{dragging=false;});canvas.addEventListener('pointercancel',()=>{dragging=false;});
  for(const axis of ['x','y'])$(`[data-fw-${axis}]`).addEventListener('input',e=>{centre[axis]=Number(e.target.value)/100;draw();});
  canvas.addEventListener('keydown',e=>{const delta={ArrowLeft:[-.01,0],ArrowRight:[.01,0],ArrowUp:[0,-.01],ArrowDown:[0,.01]}[e.key];if(!delta)return;e.preventDefault();move({x:(centre.x+delta[0])*canvas.width,y:(centre.y+delta[1])*canvas.height});});
  for(const selector of ['[data-fw-variant]','[data-fw-gap]','[data-fw-border]'])$(selector).addEventListener('change',()=>{if(ratio)say('Size updated. Drag the arrangement to position.');draw();});
  $('[data-fw-download]').addEventListener('click',()=>{
    try{canvas.toBlob(blob=>{if(!blob){say('Could not save this preview.');return;}const url=URL.createObjectURL(blob);const a=document.createElement('a');a.href=url;a.download='fremat-my-wall.png';a.click();setTimeout(()=>URL.revokeObjectURL(url),3000);},'image/png');}catch(error){say('This browser could not save the preview. You can take a screenshot.');}
  });
  if(new URLSearchParams(location.search).get('wall')==='1')document.querySelector('[data-fw-open]').click();
})();
